import { createFileRoute, redirect } from '@tanstack/react-router';
import { z } from 'zod';

import { useSesionStore } from '@/entities/usuario';
import { LoginMfaPage } from '@/pages/login-mfa';

const mfaSearchSchema = z.object({
  redirect: z.string().optional(),
});

export const Route = createFileRoute('/_public/login/mfa')({
  validateSearch: mfaSearchSchema,
  beforeLoad: () => {
    if (!useSesionStore.getState().mfaSessionToken) {
      // TanStack Router usa `throw redirect(...)` como senal de flujo,
      // no como Error real.
      // eslint-disable-next-line @typescript-eslint/only-throw-error
      throw redirect({ to: '/login' });
    }
  },
  component: LoginMfaPage,
});
